import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const BARREL = "#6f4a28";
const BARREL_HOOP = "#2e2a24";

function barrelUnit(cx: number, cy: number, cz: number, r: number, h: number): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(r * 0.86, r, h * 0.5, 9), color: BARREL, position: [cx, cy, cz] },
    { geometry: new THREE.CylinderGeometry(r, r * 0.86, h * 0.5, 9), color: BARREL, position: [cx, cy + h * 0.5, cz] },
    { geometry: new THREE.CylinderGeometry(r * 1.02, r * 1.02, 0.014, 9), color: BARREL_HOOP, position: [cx, cy + h * 0.25, cz] },
    { geometry: new THREE.CylinderGeometry(r * 0.9, r * 0.9, 0.014, 9), color: BARREL_HOOP, position: [cx, cy + h * 0.72, cz] },
  ];
}

export const fuelBarrel = defineModel({
  id: "fuel-barrel",
  batchId: "characters",
  name: "Fuel barrel",
  tags: ["good", "cargo", "fuel"],
  fits: ["carry"],
  summary: "A wooden barrel of fuel -- a carriable good for an avatar's carry socket.",
  description:
    "A single barrel with iron hoops at held scale, ported from age-of-mcp's " +
    "goods (`fuel`). Mount it in a player's or worker's `carry` socket to show " +
    "the figure hauling fuel.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => barrelUnit(0, 0.06, 0.02, 0.06, 0.13),
  animations: [],
});
